import Api from '@/services/Api';

export default {
    // Get messages for current user
    getMessages(filters = {}) {
        const params = new URLSearchParams();
        if (filters.importance) params.append('importance', filters.importance);
        if (filters.unreadOnly) params.append('unreadOnly', filters.unreadOnly);
        if (filters.searchTerm) params.append('searchTerm', filters.searchTerm);
        if (filters.limit) params.append('limit', filters.limit);

        return Api().get(`messages?${params}`);
    },

    // Get unread message count
    getUnreadCount() {
        return Api().get('messages/unread-count');
    },

    // Mark message as read
    markAsRead(messageId) {
        return Api().put(`messages/${messageId}/read`);
    },

    // Get popup messages
    getPopupMessages() {
        return Api().get('messages/popup');
    },

    // Create message (Admin only)
    createMessage(messageData) {
        return Api().post('messages', messageData);
    },

    // Get all messages with stats (Admin only)
    getAllMessagesWithStats(limit = 200) {
        return Api().get(`messages/admin?limit=${limit}`);
    },

    // Delete message (Admin only)
    deleteMessage(messageId) {
        return Api().delete(`messages/${messageId}`);
    },

    // Get message details with read status (Admin only)
    getMessageDetails(messageId) {
        return Api().get(`messages/${messageId}/details`);
    },

    // Upload image for messages (Admin only)
    uploadImage(file) {
        const formData = new FormData();
        formData.append('image', file);

        return Api().post('messages/upload-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    // Get active users
    getActiveUsers() {
        return Api().get('users/active');
    },

    // Format importance for display
    getImportanceLabel(importance) {
        const labels = {
            low: 'Niedrig',
            medium: 'Mittel',
            high: 'Hoch',
            critical: 'Kritisch'
        };
        return labels[importance] || importance;
    },

    // Get importance color
    getImportanceColor(importance) {
        const colors = {
            low: 'grey',
            medium: 'blue',
            high: 'orange',
            critical: 'red'
        };
        return colors[importance] || 'grey';
    },

    // Format date
    formatDate(date) {
        const d = new Date(date);
        const now = new Date();
        const diffMs = now - d;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'Gerade eben';
        if (diffMins < 60) return `Vor ${diffMins} Minute${diffMins > 1 ? 'n' : ''}`;
        if (diffHours < 24) return `Vor ${diffHours} Stunde${diffHours > 1 ? 'n' : ''}`;
        if (diffDays < 7) return `Vor ${diffDays} Tag${diffDays > 1 ? 'en' : ''}`;
        
        return d.toLocaleDateString('de-DE', { 
            day: '2-digit', 
            month: '2-digit', 
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    },

};